import type { TiptapEditorPlugin } from 'ricos-types';

import { breakout } from './extension';

export const pluginBreakout: TiptapEditorPlugin = {
  type: 'BREAKOUT',
  config: {},
  tiptapExtensions: [breakout],
  shortcuts: [],
  textButtons: [],
};
